export default __webpack_public_path__ + "static/media/digitalimg.097a241a.png";